import React, { useMemo, useState } from 'react';
import { Link } from 'react-navi';
import { NavBar } from '@contest-web/components/src/components';
import { Helmet } from 'react-navi-helmet-async';

function KobeCollection() {
  return (
    <div>
      <Helmet>
        <meta
          content={`9/8(日) 神戸コレクション 2019 AUTUMN/WINTER -ガールズフェスティバル-「SHOWROOM SPECIALSTAGE」にて、モデルとしてミスサークル候補者が登場しました | ${
            process.env.REACT_APP_WEBSITE_NAME
          }`}
          property="og:title"
        />
        <meta
          content={`${process.env.REACT_APP_URL}/images/news/2019-09-08-kobecollection-ogp.jpg`}
          property="og:image"
        />
        <meta content={`${process.env.REACT_APP_URL}/news/2019-09-08-kobecollection`} property="og:url" />
      </Helmet>
      <div className="hero">
        <div className="hero-head">
          <NavBar logoImageSrc="/images/logo_black.svg" />
        </div>
      </div>
      <section className="section is-padding-bottom-0">
        <div className="container">
          <nav className="breadcrumb is-right is-small-mobile" aria-label="breadcrumbs">
            <ul className="is-align-center">
              <li>
                <Link className="has-text-primary" href="/top">
                  TOP
                </Link>
              </li>
              <li className="is-active">
                <Link href={`/news/2019-09-08-kobecollection`} aria-current="page">
                  9/8(日) 神戸コレクション 2019 <br className="is-hidden-desktop" />
                  AUTUMN/WINTER -ガールズフェスティバル-「SHOWROOM SPECIALSTAGE」
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </section>
      <section className="section">
        <div className="container is-slim">
          <div className="content">
            <h3>
              9/8(日) 神戸コレクション 2019 AUTUMN/WINTER -ガールズフェスティバル-内「SHOWROOM SPECIALSTAGE」にて
              モデルとしてミスサークル候補者が登場しました。
            </h3>
            <br />
            <p>
              <img src="/images/news/2019-09-08-kobecollection.jpg" />
            </p>
            <p>
              9/8(日)に開催された「神戸コレクション 2019 AUTUMN/WINTER -ガールズフェスティバル-」内の「SHOWROOM
              SPECIALSTAGE」にて 三次審査・SHOWROOM審査においてランキング1位を獲得した、「FRESH CAMPUS CONTEST
              2019」候補者の 村上由樹さん、「MISS CIRCLE
              CONTEST2019」候補者の井手麻以花さんが神戸コレクションのランウェイを歩きました。
              <br />
              <br />
              プロのヘアメイク、スタイリストによって大変身を遂げ、本番は堂々とランウェイを歩いてくれました。
              <br />
              <br />
            </p>
            <p>
              <b>現在「MISS CIRCLE CONTEST 2019」は4次審査を開催中！</b>
            </p>
            <p>
              イベントの出場者は、下記の日程で4次審査に参加中です。 投票や動画配信など、ぜひ審査にご参加ください！
              <br />
            </p>
            <ul>
              <li>WEB審査 9月4日(水)12:00〜9月29日(日)21:59</li>
              <li>
                SHOWROOM審査
                <br />
                【予選】　9月4日(水)12:00〜9月6日(金)21:59
                <br />
                【準決勝】9月13日(金)12:00〜9月15日(日)21:59
                <br />
                【決勝】9月20日(金)12:00〜9月29日(日)21:59
              </li>
              <li>mysta審査 9月16日(月・祝)20:00〜9月29日(日)21:59</li>
            </ul>
            <br />
            <p className="has-text-centered">
              <Link className="button is-large is-primary has-text-weight-bold" href="/third">
                4次審査 候補者をチェック！
              </Link>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default KobeCollection;
